import React from 'react';
import Aux from '../hoc/Aux';
import useCustomHtmlTranslation from '../hooks/useCustomHtmlTranslation';

const impress = (props) => {
  const ht = useCustomHtmlTranslation();

  return (
  <Aux>
    <div className="main-container">
       <div className="container">
          <div className="row justify-content-center">
             <div className="col-lg-11 col-xl-10">
               <h1>{ ht('content.impress.headline') }</h1><br />
               { ht('content.impress') }
             </div>
          </div>
       </div>
    </div>
  </Aux>
  )
};

export default impress;



// WEBPACK FOOTER //
// ./src/components/Impress.js